/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 16,
    viewBox: '0 0 17.85 17.2',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M8.9.6v12.17M13.95 7.73L8.9 12.77M3.86 7.73l5.04 5.04M17.25 13.17v-2.65M.6 10.52v4.93a1.15 1.15 0 0 0 1.15 1.15H16.1a1.15 1.15 0 0 0 1.15-1.15"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/download.js